<template>
  <div class="supplies-detail width-responsiveness--centralized">
    <div class="supplies-detail__container">
      <subheader
        :title="title"
        :centralized="true"
        :path="'/gestao-de-insumos'"
        :back-button-visible="true"
      >
        <div
          slot="right-side"
          :class="{ 'supplies-detail__read-only': readOnly }"
        >
          <!-- edit action -->
          <div
            class="status-icon icon-edit-alt"
            :class="{ button_block: item.status !== 'SOLICITADO' }"
            @click="handleEdit(id)"
          >
            <md-tooltip
              v-if="item.status === 'SOLICITADO'"
              md-delay="400"
              md-direction="top"
            >
              Editar
            </md-tooltip>
            <md-tooltip
              v-if="item.status !== 'SOLICITADO'"
              md-daley="400"
              md-direction="top"
            >
              O pedido ja foi enviado para análise
            </md-tooltip>
          </div>
          <!-- delete action -->
          <div
            id="delete"
            class="status-icon icon-delete-alt"
            :class="{ button_block: item.status !== 'SOLICITADO' }"
            @click="openDeleteModal(id)"
          >
            <md-tooltip
              v-if="item.status === 'SOLICITADO'"
              md-tooltip
              md-delay="400"
              md-direction="top"
            >
              Excluir
            </md-tooltip>
            <md-tooltip
              v-if="item.status !== 'SOLICITADO'"
              md-daley="400"
              md-direction="top"
            >
              O pedido ja foi enviado para análise
            </md-tooltip>
          </div>
        </div>
      </subheader>

      <div
        v-if="loading"
        class="supplies-detail__loading"
      >
        <spinner />
      </div>
      <template v-else>
        <div class="supplies-detail__container">
          <div class="supplies-detail__detail-card">
            <p><span>Realizado em:</span> {{ date }}</p>
            <p><span>Email:</span> {{ item.requesterEmail }}</p>
            <p><span>Solicitante:</span> {{ item.requester }}</p>
          </div>
        </div>
        <div class="supplies-detail__container list">
          <table class="apoio-datatable white-head">
            <colgroup>
              <col class="column-name">
              <col class="column-quantity">
              <col class="column-expander">
            </colgroup>
            <thead>
              <tr class="apoio-datatable__header-line">
                <!-- 1 header patient name -->
                <th
                  title="DESCRIÇÃO"
                  class="column-name"
                >
                  DESCRIÇÃO
                </th>

                <!-- 2 header quantity -->
                <th
                  title="QUANTIDADE"
                  class="column-quantity"
                >
                  QUANTIDADE
                </th>

                <!-- 3 header show detail -->
                <th class="column-expander" />
              </tr>
            </thead>
          </table>

          <table class="apoio-datatable apoio-datatable-alt">
            <colgroup>
              <col class="column-name">
              <col class="column-quantity">
              <col class="column-expander">
            </colgroup>
            <tbody
              v-for="(item, rowIndex) in item.supplies"
              :key="rowIndex"
              :md-item="item"
            >
              <tr
                :id="'item' + rowIndex"
                :ref="'item' + rowIndex"
                class="apoio-datatable__line apoio-datatable-alt"
              >
                <!-- 1 cell name -->
                <td
                  class="column-name"
                  @click.prevent="openItemDetails(rowIndex)"
                >
                  <span
                    :title="item.name"
                    class="item-name-span"
                  >{{ item.name }}</span>
                </td>

                <!-- 2 cell quantity -->
                <td
                  class="column-quantity"
                  @click.prevent="openItemDetails(rowIndex)"
                >
                  <span title="QUANTIDADE">
                    {{ item.quantity }}
                  </span>
                </td>

                <!-- 3 cell show detail -->
                <td
                  class="open-item-details column-expander"
                  @click.prevent="openItemDetails(rowIndex)"
                >
                  <div v-if="loading">
                    <spinner class="small" />
                  </div>
                  <div
                    v-if="!loading"
                    class="status-icon icon-arrow-dropdown-alt"
                  >
                    <md-tooltip
                      md-delay="400"
                      md-direction="top"
                    >
                      Detalhes
                    </md-tooltip>
                  </div>
                </td>
              </tr>

              <!-- Detail row -->
              <tr
                v-if="item.expanded"
                class="row-details-alt"
              >
                <td
                  class="row-details-alt___container"
                  colspan="3"
                >
                  <div class="supplies-detail__expanded">
                    <div class="supplies-detail__expanded-title">
                      <div class="supplies-detail__expanded-reason">
                        motivo do pedido
                      </div>
                      <div
                        v-if="item.justification"
                        class="supplies-detail__expanded-justification"
                      >
                        Justificativa
                      </div>
                    </div>
                    <div class="supplies-detail__expanded-content">
                      <div class="supplies-detail__expanded-reason">
                        {{ item.reason }}
                      </div>
                      <div
                        v-if="item.justification"
                        class="supplies-detail__expanded-justification"
                      >
                        <p>
                          {{ item.justification }}
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <!-- No results table -->
            <template v-if="loading">
              <tbody>
                <tr>
                  <td
                    colspan="3"
                    style="padding: 30px"
                  >
                    Sem resultados encontrados
                  </td>
                </tr>
              </tbody>
            </template>
          </table>
        </div>
      </template>
    </div>
    <page-scroll-top />
    <supplies-delete-modal ref="deleteModal" />
    <div class="progress-bar-container">
      <div class="progress-bar width-responsiveness--centralized">
        <div class="bar_steps">
          <div
            class="step"
            :class="requestStatus"
          >
            <span class="step-title">
              <svg-loader src="/static/images/light.svg" />
              Solicitado
            </span>
            <div class="step-circle" />
            <span class="step-lastUpdate"> {{ requestUpdate }}</span>
          </div>

          <div
            class="step"
            :class="reviewSelect"
          >
            <span class="step-title">
              <svg-loader src="/static/images/file.svg" />
              Em análise
            </span>
            <div class="step-circle" />
            <span class="step-lastUpdate"> {{ reviewUpdate }} </span>
          </div>

          <div
            class="step"
            :class="logisticsSelect"
          >
            <span class="step-title">
              <svg-loader src="/static/images/shopping.svg" />
              Entregue à logística
            </span>
            <div class="step-circle" />
            <span class="step-lastUpdate"> {{ logisticsUpdate }}</span>
          </div>

          <div
            class="step"
            :class="finishedSelect"
          >
            <span class="step-title">
              <svg-loader src="/static/images/check.svg" />
              Finalizado
            </span>
            <div class="step-circle" />
            <span class="step-lastUpdate"> {{ finishedUpdate }} </span>
          </div>
        </div>

        <md-progress
          :md-progress="progress"
          :class="progressBarStatus"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import SuppliesDeleteModal from './SuppliesDeleteModal'
import SupplyService from '@/api/supply'
import { dateToLocale } from '@/utils/date-utils'
import Spinner from '../common/Spinner.vue'
import notify from '@/api/notification'

export default {
  name: 'SuppliesDetail',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    SuppliesDeleteModal,
    Spinner
  },
  data: () => {
    return {
      id: null,
      loading: false,
      loadingStatus: false,
      item: {},
      requestUpdate: '',
      reviewUpdate: '',
      logisticsUpdate: '',
      finishedUpdate: ''
    }
  },
  computed: {
    date() {
      let date = this.item.createdAt
      date = dateToLocale(date)
      return date
    },
    title() {
      let id = this.$route.params.id
      return 'Pedido ' + id
    },
    progress() {
      let status = this.item.status
      let currentUpdate = this.item.updatedAt
      let progress = 0
      switch (status) {
        case 'SOLICITADO':
          progress = 25
          this.requestUpdate = dateToLocale(this.item.createdAt, true)
          break
        case 'EM ANÁLISE':
          progress = 50
          this.reviewUpdate = dateToLocale(currentUpdate, true)
          break
        case 'EM ATENDIMENTO':
          progress = 50
          this.reviewUpdate = dateToLocale(currentUpdate, true)
          break
        case 'ENTREGUE À LOGÍSTICA':
          progress = 75
          this.logisticsUpdate = dateToLocale(currentUpdate, true)
          break
        case 'CANCELADO':
          progress = 100
          this.finishedUpdate = dateToLocale(currentUpdate, true)
          break
        case 'FINALIZADO':
          progress = 100
          this.finishedUpdate = dateToLocale(currentUpdate, true)
          break
      }

      if (this.item.statusHist) {
        this.item.statusHist.map(update => {
          if (update.status == 'SOLICITADO') {
            this.requestUpdate = dateToLocale(this.item.createdAt, true)
          } else if (update.status == 'FINALIZADO') {
            this.finishedUpdate = dateToLocale(update.changedDate, true)
          } else if (update.status == 'ENTREGUE À LOGÍSTICA') {
            this.logisticsUpdate = dateToLocale(update.changedDate)
          } else if (update.status == 'EM ANÁLISE') {
            this.reviewUpdate = dateToLocale(update.changedDate)
          } else if (update.states == 'EM ATENDIMENTO') {
            this.reviewUpdate = dateToLocale(update.changedDate)
          } else if (update.states == 'CANCELADO') {
            this.reviewUpdate = dateToLocale(update.changedDate)
          }
        })
      }
      return progress
    },
    readOnly() {
      const request = this.item
      if (request && request.sentForAnalysis) {
        return true
      }
      return false
    },
    requestStatus() {
      let style = ''
      switch (this.progress) {
        case 25:
          style = 'request-select actualStep'
          return style
        case 50:
        case 75:
        case 100:
          style = 'request-select'
          return style
      }
    },
    reviewSelect() {
      let style = ''
      switch (this.progress) {
        case 50:
          style = 'review-select actualStep'
          return style
        case 75:
        case 100:
          style = 'review-select'
          return style
      }
    },
    logisticsSelect() {
      let style = ''
      switch (this.progress) {
        case 75:
          style = 'logistics-select actualStep'
          return style
        case 100:
          style = 'logistics-select'
          return style
      }
    },
    finishedSelect() {
      if (this.progress === 100) {
        return 'finished-select actualStep'
      }
    },
    progressBarStatus() {
      let progressStatus = ''
      switch (this.progress) {
        case 25:
          progressStatus = 'request'
          return progressStatus
        case 50:
          progressStatus = 'review'
          return progressStatus
        case 75:
          progressStatus = 'logistics'
          return progressStatus
        case 100:
          progressStatus = 'finished'
          return progressStatus
      }
    }
  },
  mounted() {
    let id = this.$route.params.id
    if (id) {
      this.id = id
      this.loading = true
      SupplyService.getSupplyRequest(id)
        .then(response => {
          this.loading = false
          let item = response.data
          item.supplies = item.supplies.map(supply => {
            supply.expanded = false
            return supply
          })
          this.item = item
        })
        .catch(() => {
          this.loading = false
          notify({
            title: 'Aviso',
            message: 'Não foi possível carregar pedido.'
          })
        })
    }
  },
  methods: {
    handleEdit(id) {
      if (this.item.status === 'SOLICITADO') {
        if (!this.readOnly) {
          this.$router.push({
            path: '/gestao-de-insumos/editar-solicitacao/' + id
          })
        }
      }
    },
    openItemDetails(index) {
      const expanded = this.item.supplies[index].expanded
      this.item.supplies[index].expanded = !expanded
      let element = document.getElementById('item' + index)
      element.classList.toggle('active')
    },
    openDeleteModal(id) {
      if (this.item.status === 'SOLICITADO') {
        this.$refs.deleteModal.openModal(id)
      }
    }
  }
}
</script>

<style lang="scss">
  .supplies-detail {
    font-family: 'Exo 2', sans-serif;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 58px);
    margin-top: 150px;

    &__loading {
      min-height: 65vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__container {
      width: 100%;
    }

    &__read-only {
      & > div {
        cursor: not-allowed;
      }
    }

    &__detail-card {
      border-left: 2px solid #e2245a;
      padding-left: 14px;
      margin-bottom: 35px;

      p {
        color: #5a5a5a;
        font-weight: 500;
        font-size: 13.33px;
        line-height: 18px;

        span {
          color: #818181;
        }
      }
    }

    .subheader {
      &__title {
        h2 {
          font-weight: bold !important;
        }
      }
    }

    .apoio-datatable__line.active {
      border-color: #fff !important;
    }

    .sort-icon {
      position: absolute;
    }

    .apoio-datatable {
      margin-top: 0 !important;
    }

    .white-head {
      position: relative;
    }

    .white-head:after {
      width: calc(100% - 30px);
      z-index: 1;
      margin: 0 15px;
    }

    .column-expander {
      width: 8% !important;
    }

    tr.apoio-datatable__header-line th {
      padding: 12px 16px;
    }

    .apoio-datatable td:first-child {
      padding-left: 16px;
    }

    .apoio-datatable td {
      padding-top: 12px;
      padding-bottom: 12px;
    }

    td.row-details-alt___container {
      background-color: #fff !important;
      padding: 0 16px !important;
    }

    td.column-quantity {
      padding-left: 20px;
    }

    &__expanded {
      background-color: #ebebeb;
      padding: 10px 20px;
      border-radius: 3px;
      margin-bottom: 15px;
    }

    &__expanded-title {
      display: flex;
      border-bottom: 2px solid #fff;
      padding: 5px 0 10px;
      margin-bottom: 15px;
      color: #7a7a7a;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 12px;
    }

    &__expanded-content {
      display: flex;
    }

    &__expanded-reason {
      width: 40%;
      text-align: left;
    }

    &__expanded-justification {
      width: 60%;
      text-align: left;
    }

    .apoio-datatable tbody:last-child td:last-of-type {
      border-radius: 0 !important;
    }

    &__expanded-content {
      color: #7a7a7a;
      font-size: 13.3px;
      white-space: initial;
      padding-bottom: 10px;
    }

    td.row-details-alt___container {
      border-radius: 0 !important;
    }

    .apoio-datatable-alt tr:hover td {
      background-color: #f3f3f3;
    }

    .apoio-datatable tbody:last-of-type td.row-details-alt___container {
      border-radius: 0 0 8px 8px !important;
    }

    .apoio-datatable tbody:last-of-type tr:not(.active) .column-name {
      border-radius: 0 0 0 8px !important;
    }

    .apoio-datatable tbody:last-of-type .active .column-name {
      border-radius: 0 !important;
    }

    .icon-delete-alt,
    .icon-edit-alt {
      margin-right: 5px;
      width: 32px;
      height: 32px;
    }

    .button_block {
      background-color: #ccc;
      cursor: not-allowed;
    }

    .md-icon {
      margin-right: 8px;
    }
  }

  body .supplies-detail .apoio-datatable tbody:last-of-type .column-expander {
    border-radius: 0 0 8px 0 !important;
  }

  body .supplies-detail .apoio-datatable tbody:last-of-type .active .column-expander {
    border-radius: 0 !important;
  }

  .actualStep {
    color: #5a5a5a;
    .step-circle {
      width: 25px !important;
      height: 25px !important;
      border: 3px solid white;
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.18);
    }

    .step-title {
      color: #5a5a5a;
    }
  }

  .progress-bar-container {
    height: 130px;
    bottom: 0;
    width: 100%;
    position: fixed;
    margin-top: 50px;
    border-top: 1px solid #ccc;
    background-color: #ebebeb !important;
  }

  .progress-bar {
    width: 100%;
    margin-left: 0;
    background-color: #ebebeb !important;

    .bar_steps {
      z-index: 9999;
      width: 100%;
      position: relative;
      display: flex;
      margin-bottom: -65px;

      .step {
        height: 130px;
        width: 25%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;

        span {
          font-size: 13.33px;
          font-weight: 400;
          font-family: 'Exo 2', sans-serif;
          color: #5a5a5a;
        }

        .step-circle {
          width: 17px;
          height: 17px;
          border-radius: 50%;
          background: #c4c4c4;
        }

        span svg {
          path {
            fill: #c4c4c4;
          }
        }
      }
    }
  }

  .request-select {
    span svg {
      path {
        fill: #f78e26 !important;
      }
    }

    .step-circle {
      background: #f78e26 !important;
    }
  }

  .review-select {
    span svg {
      path {
        fill: #f05253 !important;
      }
    }

    .step-circle {
      background: #f05253 !important;
    }
  }

  .logistics-select {
    span svg {
      path {
        fill: #ec2072 !important;
      }
    }

    .step-circle {
      background: #ec2072 !important;
    }
  }

  .finished-select {
    span svg {
      path {
        fill: #7f1a54 !important;
      }
    }

    .step-circle {
      background: #7f1a54 !important;
    }
  }

  .request {
    .md-progress-track {
      background-image: linear-gradient(to right, #ef9a4b, #ee5c53) !important;
    }
  }

  .review {
    .md-progress-track {
      background-image: linear-gradient(to right, #ef9a4b, #ee5c53) !important;
    }
  }

  .logistics {
    .md-progress-track {
      background-image: linear-gradient(to right, #ef9a4b, #ec2072) important;
    }
  }

  .finished {
    .md-progress-track {
      background-image: linear-gradient(to right, #ef9a4b, #ec2072) !important;
    }
  }

  .md-theme-default.md-progress {
    background-color: #cccccc;
  }

  .step-lastUpdate {
    height: 20px;
  }

  .step-title {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #818181;
  }

  .list {
    padding-bottom: 170px;
  }
</style>
